// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2qBZa","colMaxWidth":"Table_colMaxWidth__YBKwR"};